/* Progressive enhancement: content is always visible, including without JS. */
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const seen = new WeakSet();
  function setup(root = document) {
    if (preference.matches || !('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('s30-reveal');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.08 });
    root.querySelectorAll('.s30-section-heading, .s30-collection-card, .s30-faq, .s30-footer-top').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      observer.observe(element);
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  preference.addEventListener('change', () => {
    if (preference.matches) {
      observer?.disconnect();
      observer = undefined;
      document.querySelectorAll('.s30-reveal').forEach(el => el.classList.remove('s30-reveal'));
    } else setup();
  });
})();
